<template>
  <div
    class="nav"
    :class="{
      hidden: hidden,
      'nav-link-hovered': navLinkIsHovered,
      'keep-active-item': keepActiveItem,
      'is-touch': isTouch,
    }"
  >
    <div class="nav-wrapper">
      <navbar>
        <li class="narrow">
          Martin Legrand
          <br />Design, Direction
        </li>
        <li class="narrow last-on-mobile">
          Selected Works
          <br />14 — 23
        </li>
        <li class="wide">
          <router-link :to="{ name: 'page', params: { slug: 'information' } }"
            >About</router-link
          >
        </li>
      </navbar>

      <nav>
        <ul>
          <li>
            <!-- <nav-link slug="eji-org" mode="portrait" side="right"></nav-link>-->
          </li>
          <li>
            <nav-link
              slug="eji-org"
              mode="portrait"
              side="right"
            ></nav-link>
            <span class="separator">/</span>
            <nav-link
              slug="eji-calendar"
              mode="portrait"
              side="right"
            ></nav-link>
          </li>
          <li>
            <nav-link
              slug="eji-segregation-in-america"
              mode="landscape"
              side="right"
            ></nav-link>
          </li>
          <li>
            <nav-link
              slug="AFSC"
              mode="landscape"
              side="right"
            ></nav-link>
          <span class="separator">/</span>
            <nav-link
              slug="pivotal-venture"
              mode="portrait"
              side="right"
            ></nav-link>
          </li>
          <li class="left">
            <nav-link
              slug="LCAUxMIT"
              mode="landscape"
              side="right"
            ></nav-link>
          </li>
          <li class="right">
            <nav-link
              slug="innocence-project"
              mode="portrait"
              side="left"
            ></nav-link>
          </li>
          <li class="right">
            <nav-link
              slug="christian-louboutin"
              mode="portrait"
              side="left"
            ></nav-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>


<script>
import NavLink from "@/components/NavLink";
import Navbar from "@/components/Navbar";
import { mapState } from "vuex";

export default {
  props: {
    isTouch: Boolean,
    hidden: Boolean,
    keepActiveItem: Boolean,
  },
  data() {
    return {};
  },
  components: {
    NavLink,
    Navbar,
  },
  computed: {
    ...mapState(["navLinkIsHovered"]),
  },
};
</script>


<style lang="scss">
@import "@/styles/mixins.scss";

.nav {
  background-color: var(--nav-background-color);
  overflow: scroll;
  height: calc(var(--vh, 1vh) * 100);
  width: 100%;
  box-sizing: border-box;

  &.is-touch {
    transition: opacity var(--small-animations-duration)
      var(--small-animations-duration);

    &.hidden {
      opacity: 0;
      transition-delay: 0s;
    }
  }

  &:not(.is-touch) {
    transition: background-color var(--small-animations-duration);


    &.nav-link-hovered{
      background-color: var(--nav-background-color-project-hovered);
    }

    &.keep-active-item{
      background-color: var(--nav-background-color-project-active);
    }

    &.nav-link-hovered,
    &.keep-active-item {
      nav {
        ul li {
          a {
            &:hover,
            &.router-link-active {
              opacity: 1 !important;
              z-index: var(--z-index-nav-link);

              .image {
                &.portrait {
                  width: var(--nav-portrait-width);
                }
                &.landscape {
                  width: var(--nav-landscape-width);
                }
                &.left {
                  img {
                    transform: translateX(0);
                  }
                }
              }
            }
          }
          a,
          .separator {
            opacity: 0.1;
          }
        }
      }
    }
  }

  .nav-wrapper {
    display: flex;
    flex-direction: column;
    min-height: calc(var(--vh, 1vh) * 100);
    justify-content: flex-start;

    nav {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      font-family: var(--nav-font-family);
      letter-spacing: var(--nav-letter-spacing);
      font-weight: var(--nav-font-weight);

      @include breakpoint(xs) {
        font-size: var(--nav-font-size-mobile);
        line-height: var(--nav-line-height-mobile);
        padding: var(--nav-padding-mobile);
      }

      @include breakpoint(sm) {
        font-size: var(--nav-font-size-tablet);
        line-height: var(--nav-line-height-tablet);
        padding: var(--nav-padding-tablet);
      }

      @include breakpoint(md) {
        font-size: var(--nav-font-size);
        line-height: var(--nav-line-height);
        padding: var(--nav-padding);
      }

      ul {
        padding: 0;
        margin: 0;
        list-style: none;
        width: 100%;

        @include breakpoint(xs) {
          .separator {
            display: none;
          }

          li {
            text-align: left !important;
            a {
              display: block !important;
              padding: var(--nav-link-padding-mobile);
            }
          }
        }

        li {
          transition: opacity var(--small-animations-duration);

          &.center {
            text-align: center;
          }

          &.right {
            text-align: right;
          }

          .separator {
            transition: opacity var(--small-animations-duration);
            margin: 0 1vw;
            font-weight: 100;
          }

          a {
            position: relative;
            display: inline-block;
            transition: opacity var(--small-animations-duration);

            .image {
              width: 0px;
              overflow: hidden;
              pointer-events: none;
              position: absolute;
              bottom: 1px;
              z-index: var(--z-index-nav-image);
              transition: width var(--small-animations-duration)
                var(--small-animations-easing);

              @include breakpoint(xs) {
                display: none;
              }

              img {
                object-fit: cover;
                transition: transform var(--small-animations-duration)
                  var(--small-animations-easing);
              }

              &.left {
                transform: translateX(calc(-100% - var(--nav-image-spacing)));

                img {
                  transform: translateX(-100%);
                }
              }

              &.right {
                transform: translateX(var(--nav-image-spacing));
              }

              &.portrait {
                height: var(--nav-portrait-height);
                img {
                  width: var(--nav-portrait-width);
                  height: var(--nav-portrait-height);
                }
              }

              &.landscape {
                height: var(--nav-landscape-height);
                img {
                  width: var(--nav-landscape-width);
                  height: var(--nav-landscape-height);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>